import {Proposal} from "../../types/Proposal";
import TelegramIcon from "@mui/icons-material/Telegram";
import {IconButton, Tooltip} from "@mui/material";
import React from "react";
import {useMutation} from "@tanstack/react-query";
import {DefaultError} from "@tanstack/query-core";
import {sendToTelegram} from "../../service/proposal.service";
import {enqueueSnackbar} from "notistack";
import dayjs from "dayjs";
import {SxProps} from "@mui/system";

export function TelegramButton({sx, proposal, callback}:{callback:(proposal:Proposal) => void, sx?: SxProps, proposal: Proposal}) {

    const sendToTelegramMutation = useMutation<void, DefaultError, void>({
        mutationFn: () => sendToTelegram(proposal.id)
            .then(r => {
                enqueueSnackbar({variant: "success", message: "Sent"})
                callback(proposal)
                return r.data
            }),
        onError: (error) => {
            enqueueSnackbar({message: "Failed to deliver message to telegram channel: " + error.message, variant: 'error'})
        }
    });

    return <Tooltip sx={sx} title={proposal.telegramSendDate
        ? "Sent to telegram at " + dayjs(proposal.telegramSendDate).format('YYYY-MM-DD HH:mm')
        : "Was not published in telegram channel"}>
        <IconButton onClick={() => sendToTelegramMutation.mutate()}>
            <TelegramIcon color={proposal.telegramSendDate ? "disabled" : "primary"}/>
        </IconButton>
    </Tooltip>
}